<template>
  <div class="ctn-user-search">
    <v-container>
      <v-row>
        <v-autocomplete
          v-model="user"
          :items="entries"
          :loading="isLoading"
          :search-input.sync="search"
          @keyup.enter="searchBarItems"
          @input="selectUser"
          hide-no-data
          :item-text="itemText"
          :autofocus="true"
          item-value="user_data.id"
          label="Ingrese un usuario"
          append-outer-icon="mdi-magnify"
          @click:append-outer="searchBarItems"
          :clearable="true"
          @click:clear="removeCurrentUser"
          return-object
        >
          <template v-slot:item="data">
            <div>
              <span style="display: inline-block; width:100%;">{{data.item.email}}</span>
              <span style="font-size: 11px;float:left;">{{data.item.user_data.display_name}}</span>
            </div>
          </template>
        </v-autocomplete>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UserSearch.vue",
  data() {
    return {
      descriptionLimit: 60,
      isLoading: false,
      user: null,
      search: null,
      entries: [],
    };
  },
  props: ["searchBy", "itemText"],
  computed: {
    ...mapState("user", ["users", "info", "currentUser"]),
  },
  methods: {
    ...mapActions("user", [
      "fetchInfo",
      "updateInfo",
      "getUsers",
      "updateCurrentUser",
    ]),
    ...mapActions(["loaderChange"]),
    searchBarItems() {
      this.isLoading = true
      let val = this.search
      let req = {
        val: val,
        searchBy: this.searchBy,
      }
      this.getUsers(req)
        .then(() => {
          this.entries = this.users.users.data
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    selectUser(val) {
      if (val.id) {
        this.updateCurrentUser(val.id);
        this.$emit("changeUser");
      }
    },
    removeCurrentUser() {
      this.updateCurrentUser("");
      // this.$emit("changeUser");
    },
  },
};
</script>

<style scoped>
</style>
